import { useState, useEffect } from "react";

export function useDebounce<T>(value: T, delay: number = 200): T {
  // State to hold the debounced value
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    // Set up a timeout to update debounced value after the specified delay
    const handler = setTimeout(() => setDebounced(value), delay);
    // Clear timeout if value or delay changes (cleanup)
    return () => clearTimeout(handler);
  }, [value, delay]);

  // Return the debounced value for use in components
  return debounced;
}
